<div class="document-cell-renderer__documents">
  <div class="document-cell-renderer__documents-list">
    {{ cellValue }}
  </div>
  <div class="document-cell-renderer__button-cell">
    <button
      *ngIf="!cellValue"
      edsButton="primary"
      (click)="subscribeDocuments()"
      [edsSpacing]="(isHandheld$ | async) ? 'xs' : 'none'"
      edsPadding
      edsPaddingTop="xs"
      edsPaddingBottom="xs"
      size="compact"
      type="button"
    >
      {{ "subscriptions.subscribe" | translate }}
    </button>
    <button
      *ngIf="cellValue"
      edsButton="primary"
      (click)="unsubscribeDocuments()"
      [edsSpacing]="(isHandheld$ | async) ? 'xs' : 'null'"
      edsPadding
      edsPaddingTop="xs"
      edsPaddingBottom="xs"
      size="compact"
      type="button"
    >
      {{ "subscriptions.unsubscribe" | translate }}
    </button>
    <button
      edsButton="secondary-light"
      (click)="editDocuments()"
      edsPadding
      edsPaddingTop="xs"
      edsPaddingBottom="xs"
      [hasIcon]="true"
      [ngClass]="'document-cell-renderer__edit-button'"
      size="compact"
      type="button"
    >
      {{ "subscriptions.edit" | translate }}
      &nbsp;
      <eds-icon size="small" type="edit"></eds-icon>
    </button>
  </div>
</div>
